import { Link } from "@remix-run/react";

export function Subscribe({
  company,
  center = false,
  id = "",
}: {
  company?: string;
  center?: boolean;
  id?: string;
}) {
  return (
    <div
      className={`mb-12 shrink ${
        center ? "text-center w-full " : "ml-auto"
      } text-gray-300 text-xl flex flex-col gap-5`}
    >
      <h2>
        Get{" "}
        <span className="underline italic decoration-lime-400">notified</span>{" "}
        {company ? (
          <>when {company} posts a new job </>
        ) : (
          <>about new job opportunities</>
        )}
      </h2>
      <Link
        to={`/?ref=company-page${id ? "-" + id : ""}-${company || ""}`}
        className={`bg-lime-400 rounded-xl text-gray-700 text-center justify-center px-4 py-2 text-sm font-medium ${
          center ? "m-auto" : "ml-auto"
        }`}
      >
        Subscribe
      </Link>
    </div>
  );
}
